import React, {useState} from 'react';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {GrLocation,GrLocationPin} from 'react-icons/gr';
import sp from '../imgs/offer1.png';
import last from '../imgs/lastS.png';



import  validation from './Validation'

import Popup from './Popup';




const Booking = () => {

 
  const[values,setValues]=useState({
    fullName:'',
    email:'',
    kids:'',
    adults:''
  })


  const[errors, setErrors] = useState({});



    const [buttonPopup, setButtonPopup]=useState(false);
    const [addclass, setaddclass] = useState("");
    const [selectedDate, setselectedDate] = useState("");
    const [timedPopup, setTimedPopup] = useState(false);

  

const handleChange = (event) => {
  setValues({
    ...values,
    [event.target.name] : event.target.value,
    
  })
}

    const handleSubmit = (e) => {
      e.preventDefault();
      setaddclass("right-panel-active");
      // setErrors(validation(values));
    }


    const handleSubmit2 = (e) => {
      e.preventDefault();
      setButtonPopup(true)
      // setErrors(validation(values));
    }


  return (
      <section className='section-books'>
        
        <img src={sp} className='sp'/>
       
    <div className={`container ${addclass}`} id="container">
      <div className="form-container  sign-up-container">
        <form onSubmit={handleSubmit2}>
          <div className='form__group'>

            <h3 className='form__group-date'>When are you planning to visit?</h3>

          </div>


          <div className='form__group'>
            <DatePicker selected={selectedDate} className='customDatePickerWidth' onChange={date =>setselectedDate(date)}
              dateFormat='dd/MM/yyyy'
              minDate={new Date()

              }

             
            
            />
          </div>
        <img src={last} className='last'/>

          <div className='form__group'>
              
        <h3 className='form__group-date form__group-date-1'>Which tours are you most interested in?</h3>
        <div className='form__group-container'>
        <input type="checkbox" id="7won" name="7W"  value="7W"  />
        <label id='7won'>7 Wonders Tour</label>
        </div>
        <div className='form__group-container'>
        <input type="checkbox" id="Sight" name="ST" value="ST1"/>
        <label id='Sight'>Sightseeing Tour</label>
        </div>
        <div className='form__group-container'>
        <input type="checkbox" id="Shore" name="SH" value="SH1"/>
        <label id='Shore'>Shore Excrusion Tours</label>
        </div>
        <div className='form__group-container'>
        <input type="checkbox" id="Adv" name="AandS" value="AandS1"/>
        <label id='Adv'>Adventure or Sporting Tour</label>
        </div>
        </div>

        <div className='form__group'>
        
        <div>
        <label id='AdultN' className='form__group-date'>Number Of Adults</label>
        <div className='adult-input'>
        <input type='text' id='AdultN' className='AdultN' name='adults' placeholder='Enter Number' onChange={handleChange} value={values.adults} required/> 
        
        </div>
        </div>

              <div>
        <label id='KidsN' className='form__group-date'>Number Of Kids Aged 0 to 5</label>
        <div className='kids-input'>
        <input type='text' id='KidsN' className='KidsN' name='kids' placeholder='Enter Number' onChange={handleChange} value={values.kids} required/> 
        </div>
        </div>

        <div>
        <label id='comments' className='form__group-date'>Comments</label>
        <div className='comments-input'>
          <textarea id='comments' rows='2' cols='50' className='comments-section'></textarea>
        {/* <input type='text' id='coment' className='coment' required/>  */}
        </div>
        </div>

    </div>
          <button className='btn btn--green btn-book register'onClick= {() =>!values ? setValues(values):handleSubmit2 }>REGISTER</button>

     
      
        </form>
      
      </div>
     
      <div className="form-container sign-in-container">
        <form onSubmit={handleSubmit}>
            <div className='u-margin-bottom-medium u-margin-top-medium'>
          <h2 className='heading-secondary heading-secondary-booking'>Start Booking Now</h2>
          </div>
          <div className='form__group'>
          <input type="text" className='form__input form__name' placeholder="Full Name" name='fullName' id='name'  onChange={handleChange} value={values.fullName} required />
          <label htmlFor='name' className='form__label'>Full Name</label>
          {errors.fullName && <p className='error'>{errors.fullName}</p>}
          </div>
          <div className='form__group'>
          <input type="email" className='form__input form__email' placeholder="Email address" name='email' id='email'  value={values.email} onChange={handleChange} required />
          <label htmlFor='email' className='form__label'>Email address</label>
          {errors.email && <p className='error'>{errors.email}</p>}

          </div>
        
          <div className='form__group'>
              <div className='form__radio-group'>
                <input type='radio' className='form__radio-input'  id='solo' value={values.size} name='size' onChange={handleChange}/>
                <label htmlFor='solo' className='form__radio-label'><span className='form__radio-button'></span>Solo Tour</label>

              </div>

          </div>
          <div className='form__group'>
              <div className='form__radio-group'>
                <input type='radio' className='form__radio-input' id='group' value={values.size} onChange={handleChange} name='size' />
                <label htmlFor='group' className='form__radio-label'><span className='form__radio-button'></span>Group Tour</label>

              </div>

          </div>
          <div className='form__group'>
      
          <button className='btn btn--green btn-book' onClick= {() =>!values ? setValues(values): handleSubmit} >Next Step&rarr;</button>
          </div>
        </form>
      </div>
      <div className="overlay-container">
        <div className="overlay">
          <div className="overlay-panel overlay-left">
            <button
              className="ghost btn btn-green"
              id="signIn"
              onClick={() => setaddclass("")}
            >
              GO TO LOGIN
            </button>
          </div>
          <div className="overlay-panel overlay-right">

            <h2 className='heading-secondary other'>Complete your booking in just 2 steps</h2>
            {/* <button
              className="ghost"
              id="signUp"
              onClick={() => setaddclass("right-panel-active")}
            >
              GO TO REGISTER
            </button> */}
          </div>
        </div>
      </div>
      <Popup trigger={buttonPopup} setTrigger={setButtonPopup}>
      <h1 className='heading-popUp'>Booking Done Sucessfully!</h1>
    </Popup>
    </div>
    
    </section>
  );

};


export default Booking;








